import { render, staticRenderFns } from "./product-tab.vue?vue&type=template&id=1919757c&scoped=true"
import script from "./product-tab.vue?vue&type=script&lang=js"
export * from "./product-tab.vue?vue&type=script&lang=js"
import style0 from "./product-tab.vue?vue&type=style&index=0&id=1919757c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919757c",
  null
  
)

export default component.exports